import React from "react";
import circles from "../../../assets/img/landings/circles.svg";
import "./index.css";
import RequestDemo from "../../Button/RequestDemo";
import btnClasses from "../../commons/Button.module.scss";

const Hero = ({ title, subtitle, children }) => {
  return (
    <section className="hero">
      <div className="container">
        <div className="hero__body">
          <article className="hero__content">
            <div className="hero__bgr">
              <img src={circles} alt="circles" />
            </div>
            <h1 className="hero__title">{title}</h1>
            <h2 className="hero__subtitle">{subtitle}</h2>
            {children[0]}
            <RequestDemo className={btnClasses.button} />
          </article>
          <div className="hero__image">{children[1]}</div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
